<div *ngIf="schoolStatus.length != 0" class="container-fluid" id="assessmentPrint">
    <div class="row">
        <div class="col-12">
            <div class="card-body tab2-card p-0">
                <form [formGroup]="assessmentForm" class="needs-validation user-add">
                    <div class="row">
                        <div class="form-group col-3 px-0">
                            <label class="col-xl-12 col-md-12 px-2"><span style="visibility: hidden">*</span>
                                Class List</label>
                            <div class="col-xl-12 col-md-12">
                                <ng-select (change)="assessmentReport(); assignmentReport()"
                                           [items]="classDetails"
                                           bindLabel="class_name"
                                           bindValue="class_id"
                                           formControlName="class"
                                           placeholder="Class List">
                                </ng-select>
                            </div>
                        </div>
                        <div class="form-group col-3 px-0" *ngIf="assessmentShow">
                            <label class="col-xl-12 col-md-12 px-2"><span style="visibility: hidden">*</span> From Date</label>
                            <div class="col-xl-12 col-md-12 form-group">
                                <div class="input-group">
                                    <input class="form-control" name="fromdate" placeholder="mm/dd/yyyy"
                                           formControlName="fromDate" angular-mydatepicker #dp="angular-mydatepicker" [options]="myDpOptions" (dateChanged)="onDateChanged1($event, '1')"/>
                                    <div class="input-group-append">
                                        <button type="button" class="btn btn-primary px-3 py-1" (click)="dp.toggleCalendar()">
                                            <i class="fa fa-calendar-o"></i>
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="form-group col-3 px-0" *ngIf="assessmentShow">
                            <label class="col-xl-12 col-md-12 px-2"><span style="visibility: hidden">*</span> To Date</label>
                            <div class="col-xl-12 col-md-12 form-group">
                                <div class="input-group">
                                    <input class="form-control" name="todate" placeholder="mm/dd/yyyy"
                                           formControlName="toDate" angular-mydatepicker #dp1="angular-mydatepicker" [options]="myDpOptions1" (dateChanged)="onDateChanged1($event, '2')"/>
                                    <div class="input-group-append">
                                        <button type="button" class="btn btn-primary px-3 py-1" (click)="dp1.toggleCalendar()">
                                            <i class="fa fa-calendar-o"></i>
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div *ngIf="assessmentReportShow" [ngClass]="assessmentShow == true ? 'col-3' : 'col-9'">
                            <div class="row group-btn mt-3">
                                <div class="col-12 text-right">
                                    <button type="button" class="btn btn-primary" (click)="assessmentPrint()">Print</button>
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-3 px-0" *ngIf="assessmentShow">
                            <label class="col-xl-12 col-md-12 px-2"><span style="visibility: hidden">*</span> Assessment List</label>
                            <div class="col-xl-12 col-md-12">
                                <ng-select (change)="assessmentDetailReport()"
                                           [items]="assessmentDetails"
                                           bindLabel="content_name"
                                           bindValue="content_id"
                                           formControlName="assessment"
                                           placeholder="Please Select"
                                           typeToSearchText=""
                                           multiple="true">
                                </ng-select>
                            </div>
                        </div>
                        <div class="form-group col-3 px-0" *ngIf="assessmentShow">
                            <label class="col-xl-12 col-md-12 px-2"><span style="visibility: hidden">*</span> Assignment List</label>
                            <div class="col-xl-12 col-md-12">
                                <ng-select (change)="assignmentDetailReport()"
                                           [items]="assignmentDetails"
                                           bindLabel="content_name"
                                           bindValue="content_id"
                                           formControlName="assignment"
                                           placeholder="Please Select"
                                           typeToSearchText=""
                                           multiple="true">
                                </ng-select>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="row d-flex justify-content-between mt-3" *ngIf="assessmentReportShow">
        <div class="col-6">
            <div class="card p-3">
                <h3>Assessment Statistics</h3>
                <div class="row mt-3">
                    <div class="col-6  p-2">
                        <div class="bg-secondary-assessment p-3">
                            <h4 class="p-2">Average Score</h4>
                            <h4 class="p-2"><span class="letter">{{assessmentReportDetails.studentAverage}}</span> / {{assessmentReportDetails.totalAverage}}</h4>
                        </div>
                    </div>
                    <div class="col-6 p-2">
                        <div class="bg-secondary-assessment p-3">
                            <h4 class="p-2">Average student Score</h4>
                            <h4 class="p-2"><span class="letter">{{assessmentReportDetails.AverageStudentScore}}</span></h4>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-4">
                        <h4 class="text-secondary-assessment">Students Assigned</h4>
                        <h4 class="letter">{{assessmentReportDetails.totalStudentAssigned}}</h4>
                    </div>
                    <div class="col-4">
                        <h4 class="text-secondary-assessment">Students Graded</h4>
                        <h4 class="letter">{{assessmentReportDetails.totalStudentGraded}}</h4>
                    </div>
                    <div class="col-4">
                        <h4 class="text-secondary-assessment">Students Absent</h4>
                        <h4 class="letter">{{assessmentReportDetails.totalAbsent}}</h4>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-6">
            <div class="card p-3">
                <div class="row">
                    <div class="col-12">
                        <h3>Students Assessment Performance Bands (%)</h3>
                        <div id="chart">
                            <apx-chart
                                    [series]="chartOptions.series"
                                    [chart]="chartOptions.chart"
                                    [labels]="chartOptions.labels"
                                    [responsive]="chartOptions.responsive"
                            ></apx-chart>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 mt-3">
            <div class="card p-3">
                <div class="row">
                    <div class="col-6">
                        <h3>Assessment Statistics</h3>
                    </div>
                    <div class="col-6 text-right">
                        <button type="button" class="btn btn-success" (click)="downloadExcelData()">Download CSV</button>
                    </div>
                    <div class="col-12 mt-2">
                        <div id="batchDelete" class="category-table custom-datatable transcation-datatable user-image">
                            <div class="table-responsive">
                                <app-table [TableType]="'ReportAssessment'" [TableArray]="listData" (clickValue)="viewDetail($event)" ></app-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row d-flex justify-content-between mt-3" *ngIf="assignmentReportShow">
        <div class="col-6">
            <div class="card p-3">
                <h3>Assignment Statistics</h3>
                <div class="row mt-3">
                    <div class="col-6  p-2">
                        <div class="bg-secondary-assessment p-3">
                            <h4 class="p-2">Average Score</h4>
                            <h4 class="p-2"><span class="letter">{{assignmentReportDetails.studentAverage}}</span> / {{assignmentReportDetails.totalAverage}}</h4>
                        </div>
                    </div>
                    <div class="col-6 p-2">
                        <div class="bg-secondary-assessment p-3">
                            <h4 class="p-2">Average student Score</h4>
                            <h4 class="p-2"><span class="letter">{{assignmentReportDetails.AverageStudentScore}}</span></h4>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-4">
                        <h4 class="text-secondary-assessment">Students Assigned</h4>
                        <h4 class="letter">{{assignmentReportDetails.totalStudentAssigned}}</h4>
                    </div>
                    <div class="col-4">
                        <h4 class="text-secondary-assessment">Students Graded</h4>
                        <h4 class="letter">{{assignmentReportDetails.totalStudentGraded}}</h4>
                    </div>
                    <div class="col-4">
                        <h4 class="text-secondary-assessment">Students Absent</h4>
                        <h4 class="letter">{{assignmentReportDetails.totalAbsent}}</h4>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-6">
            <div class="card p-3">
                <div class="row">
                    <div class="col-12">
                        <h3>Students Assignment Performance Bands (%)</h3>
                        <div id="chart1">
                            <apx-chart
                                    [series]="chartOptions1.series"
                                    [chart]="chartOptions1.chart"
                                    [labels]="chartOptions1.labels"
                                    [responsive]="chartOptions1.responsive"
                            ></apx-chart>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 mt-3">
            <div class="card p-3">
                <div class="row">
                    <div class="col-6">
                        <h3>Assignment Statistics</h3>
                    </div>
                    <div class="col-6 text-right">
                        <button type="button" class="btn btn-success" (click)="downloadAssignmentExcelData()">Download CSV</button>
                    </div>
                    <div class="col-12 mt-2">
                        <div id="batchDelete1" class="category-table custom-datatable transcation-datatable user-image">
                            <div class="table-responsive">
                                <app-table [TableType]="'ReportAssignment'" [TableArray]="listData1" (clickValue)="viewDetail($event)" ></app-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row d-flex justify-content-center list-card mt-3 px-3" *ngIf="!assessmentReportShow && !assignmentReportShow">
        <div class="col-12 p-0">
            <button class="nodataList">{{message}}</button>
        </div>
    </div>
</div>
<div *ngIf="schoolStatus.length == 0">
    <app-emptyschool>
    </app-emptyschool>
</div>
<ng-template #viewStudentDetails let-c="close" let-d="dismiss">
    <div class="modal-body">
        <!-- Container-fluid starts-->
        <div [hidden]="correctionData == true"  class="container-fluid">
            <div class="row">
                <div class="col-md-12 modal-header">
                    <h4 class="modal-title">Itemized Reports</h4>
                    <p class="text-right">
                        <i class="fa fa-close fa-2x" aria-hidden="true" style="cursor:pointer" (click)="close()"></i>
                    </p>
                </div>
                <div class="col-md-12 mb-2">
                    <div id="chart2">
                        <apx-chart
                                [series]="chartOptions2.series"
                                [chart]="chartOptions2.chart"
                                [dataLabels]="chartOptions2.dataLabels"
                                [plotOptions]="chartOptions2.plotOptions"
                                [responsive]="chartOptions2.responsive"
                                [xaxis]="chartOptions2.xaxis"
                                [legend]="chartOptions2.legend"
                                [fill]="chartOptions2.fill"
                        ></apx-chart>
                    </div>
                </div>
                <div class="col-6">
                    <h3>Student Statistics</h3>
                </div>
                <div class="col-6 text-right">
                    <button type="button" class="btn btn-success" (click)="downloadStudentExcelData()">Download CSV</button>
                </div>
                <div class="col-12 mt-2">
                    <div id="batchDelete2" class="category-table custom-datatable transcation-datatable user-image">
                        <div class="table-responsive">
                            <app-table [TableType]="'StudentReport'" [TableArray]="listData2" (clickValue)="studentCorrectionDetail($event)"></app-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="correctionData == true" class="container-fluid">
            <div class="row">
                <div class="col-md-12 modal-header">
                    <h4 class="modal-title">Correction Details</h4>
                    <p class="text-right">
                        <i (click)="back()" aria-hidden="true" class="fa fa-close fa-2x" style="cursor:pointer"></i>
                    </p>
                </div>
                <div [hidden]="studentAnswer.answers.length == 0" class="col-md-12 scrollPanel view-question" style="height: 100vh">
                    <div *ngFor="let sec of totalAns; let i = index" class="card mt-2 div-disable">
                        <div *ngIf="sec.heading != ''" class="col-md-12 mb-3">
                            <input [value]="sec.heading" class="input-custom-modal div-disable" type="text">
                        </div>
                        <div *ngFor="let item of sec.section; let j = index" class="card-body mb-3">
                            <div class="row d-flex justify-content-between">
                                <div class="col-md-1">
                                    <button class="btn btn-primary mr-3">{{item.sub_question_no}}</button>
                                </div>
                                <div class="col-md-3 text-right">
                                    <input (input)="getPoints($event , i, j); markValidation($event, item.points, i, j)" (keypress)="numberValidate($event)" [value]="item.given_points" autocomplete="off" class="mark-input" name="points" style="text-align: center">
                                    <input (keypress)="numberValidate($event)" [value]="item.points" class="mark-input div-disable" style="text-align: center">
                                    <br>
                                    <span *ngIf="item.maxValErr" class="errormessage">Invalid Points</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 view-question_design">
                                    <ul *ngIf="item.question_type_id == 1" class="mt-4">
                                        <p [hidden]="item.question == ''" class="mb-0 mt-2" [innerHTML]="item.question"></p>
                                        <li *ngFor="let option of item.array" [ngClass]="{'ans-correct': option == item.answer, 'ans-selected': option == item.student_answer, 'ans-wrong': option != item.answer && option == item.student_answer}"><span><span>{{option}}</span>
                            <i aria-hidden="true" class="fa fa-check"></i>
                            <i aria-hidden="true" class="fa fa-times"></i>
                        </span>
                                        </li>
                                    </ul>
                                    <ul *ngIf="item.question_type_id == 3" class="mt-4">
                                        <p [hidden]="item.question == ''" class="mb-0 mt-2" [innerHTML]="item.question"></p>
                                        <li [ngClass]="{'ans-correct': item.answer == 'true', 'ans-selected': item.student_answer == 'true', 'ans-wrong': item.answer == 'false' && item.student_answer == 'true'}">
                            <span><input [checked]="item.student_answer == 'true'" class="radio-size form-control mr-2 div-disable" name="ans" type="radio" value="true"> True
                            <i aria-hidden="true" class="fa fa-check"></i>
                            <i aria-hidden="true" class="fa fa-times"></i>
                            </span>
                                        </li>
                                        <li [ngClass]="{'ans-correct': item.answer == 'false', 'ans-selected': item.student_answer == 'false', 'ans-wrong': item.answer == 'true' && item.student_answer == 'false'}">
                            <span><input [checked]="item.student_answer == 'false'" class="radio-size form-control mr-2 div-disable" name="ans" type="radio" value="false"> False
                            <i aria-hidden="true" class="fa fa-check"></i>
                            <i aria-hidden="true" class="fa fa-times"></i>
                            </span>
                                        </li>
                                    </ul>
                                    <ul *ngIf="item.question_type_id == 9" class="mt-4">
                                        <p [hidden]="item.question == ''" class="mb-0 mt-2" [innerHTML]="item.question"></p>
                                        <li *ngFor="let option of item.mob_options" [ngClass]="{'ans-correct': option == item.answer, 'ans-selected': option == item.student_answer, 'ans-wrong': option != item.answer && option == item.student_answer}"><span class="capital">{{option}}
                                            <i aria-hidden="true" class="fa fa-check"></i>
                            <i aria-hidden="true" class="fa fa-times"></i>
                        </span></li>
                                    </ul>
                                    <div *ngIf="item.question_type_id == 10" class="col-md-6 mt-4 px-0">
                                        <p [hidden]="item.question == ''" class="mb-0 mt-2" [innerHTML]="item.question"></p>
                                        <input [ngClass]="{'wrong-ans': item.match_case ? (item.answer != item.student_answer) : (item.answer.toLowerCase() != item.student_answer.toLowerCase()),
                                'correct-ans': item.match_case ? (item.answer == item.student_answer) : (item.answer.toLowerCase() == item.student_answer.toLowerCase())}"
                                               [value]="item.student_answer"
                                               class="form-control div-disable mt-2"
                                               type="text">
                                        <label class="mt-4" value="Correct answer">Correct answer : {{item.answer}}</label>
                                    </div>
                                    <div *ngIf="item.question_type_id == 20" class="col-md-12 mt-4 px-0">
                                        <textarea class="form-control div-disable" cols="30" rows="4">{{item.student_answer}}</textarea>
                                    </div>
                                    <div *ngIf="item.question_type_id == 30" class="col-md-12 mt-4 px-0">
                                        <div class="d-flex">
                                            <label>Student Answer: </label>
                                            <h4 [innerHTML]="item.student_answer | sanitizeHtml" class="ml-3"></h4>
                                        </div>
                                        <div class="d-flex">
                                            <label>Correct Answer: </label>
                                            <h4 [innerHTML]="item.answer | sanitizeHtml" class="ml-3"></h4>
                                        </div>
                                    </div>
                                    <div *ngIf="item.question_type_id == 40" class="col-md-12 mt-4 px-0 d-flex">
                                        <div class="col-md-6 div-disable">
                                            <label>Correct Answer: </label>
                                            <app-graph-component [editMode]="false"
                                                                 [editPatchValue]="parseVal(item.answer)"
                                                                 [graphId]="i+'correctgraph'+item.sub_question_no+'id'"
                                                                 [questionType]="'40'"></app-graph-component>
                                        </div>
                                        <div class="col-md-6 div-disable">
                                            <label>Student Answer: </label>
                                            <app-graph-component *ngIf="item.student_answer != ''"
                                                                 [editMode]="false"
                                                                 [editPatchValue]="parseVal(item.student_answer[0].correctAnswer)"
                                                                 [graphId]="i+'Editgraph'+item.sub_question_no+'id'"
                                                                 [questionType]="'40'"></app-graph-component>
                                            <app-graph-component *ngIf="item.student_answer == ''"
                                                                 [editMode]="false"
                                                                 [editPatchValue]="false"
                                                                 [graphId]="i+'Editgraph'+item.sub_question_no+'idoo'"
                                                                 [questionType]="'40'"></app-graph-component>
                                        </div>
                                    </div>
                                    <div *ngIf="item.question_type_id == 54" class="col-md-12 mt-4 px-0">
                                        <div *ngFor="let blank of item.answer; let k = index">
                                                            <textarea *ngIf="item.student_answer != '' && item.student_answer != null" [ngClass]="{'correct-ans': item.match_case == '1' ? (item.answer[k].value.trim() == item.student_answer[k].trim()) : item.answer[k].value.trim().toLowerCase().split(' ').join('') == item.student_answer[k].trim().toLowerCase().split(' ').join(''),
                                                            'wrong-ans': item.match_case ? (item.answer[k].value.trim() != item.student_answer[k].trim()) : item.answer[k].value.trim().toLowerCase().split(' ').join('') != item.student_answer[k].trim().toLowerCase().split(' ').join('')}"
                                                                      [value]="item.student_answer[k]"
                                                                      class="form-control mt-2" cols="30" readonly rows="4">

                                                            </textarea>
                                            <textarea *ngIf="item.student_answer == '' || item.student_answer == null" class="form-control mt-2" cols="30" placeholder="Student Not Answered"
                                                      readonly rows="2"></textarea>
                                            <label class="mt-1">Correct Answer : {{item.answer[k].value}}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-4 d-flex">
                                <div class="col-md-6">
                                    <label>Student feedback</label>
                                    <textarea [value]="item.student_feedback == null ? '' : item.student_feedback" class="form-control div-disable" rows="3"></textarea>
                                </div>
                                <div class="col-md-6">
                                    <label>Feedback</label>
                                    <textarea (input)="getFeedback($event, i, j)" [value]="item.feedback" class="form-control div-disable" placeholder="Feed Back" rows="3"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 mt-3 card p-4">
                        <div class="col-md-12 d-flex">
                            <div class="col-md-6 px-0 mb-2">
                                <div class="col-md-12">
                                    <label>Obtained Points</label>
                                    <input [(ngModel)]="studentPoints" class="form-control div-disable" type="text">
                                </div>
                                <div class="col-md-12 mt-3">
                                    <label>Total Points</label>
                                    <input [(ngModel)]="totalPoints" class="form-control div-disable" type="text">
                                </div>
                            </div>
                            <div class="col-md-6 mb-1">
                                <label>Feedback</label>
                                <textarea [(ngModel)]="totalFeedBack" class="form-control div-disable" cols="30" rows="5"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div [hidden]="studentAnswer.answers.length != 0" class="col-md-12">
                    <app-annotation [getAnnotate]="areaInfo"
                                    [getDragQues]="dragQuestionsList"
                                    [pdfPath]="pdfTemplate"
                                    [toolHide]="true"
                                    [userType]="'teacher'"></app-annotation>
                    <div class="col-md-12 mt-3 card p-4">
                        <div class="col-md-12 d-flex">
                            <div class="col-md-6 px-0 mb-2">
                                <div class="col-md-12">
                                    <label>Obtained Points</label>
                                    <input [(ngModel)]="studentPoints" class="form-control div-disable" type="text">
                                </div>
                                <div class="col-md-12 mt-3">
                                    <label>Total Points</label>
                                    <input [(ngModel)]="totalPoints" class="form-control div-disable" type="text">
                                </div>
                            </div>
                            <div class="col-md-6 mb-1">
                                <label>Feedback</label>
                                <textarea [(ngModel)]="totalFeedBack" class="form-control div-disable" cols="30" rows="5"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</ng-template>
